<template>
  <footer class="footer" id="footer" v-if="getContentLoaded">

        <section class="section footer-lower">
          <div class="container">
            <div class="links-secondary">

              <div class="columns">
                <div class="column"></div>
                <div class="column">
                  Follow us
                  <div class="social-buttons">
                    <a href="https://www.facebook.com/camactors/" class="social-button" target="_blank"><img src="/images/social/icon_facebook.svg" width="29" height="30" alt="Facebook"></a>
                    <a href="https://twitter.com/camactors" class="social-button" target="_blank"><img src="/images/social/icon_twitter.svg" width="29" height="30" alt="Twitter"></a>
                    <a href="https://www.youtube.com/results?search_query=%22combined+actors+of+cambridge%22" class="social-button" target="_blank"><img src="/images/social/icon_youtube.svg" width="29" height="30" alt="YouTube"></a>

                    <!-- <a href="#" class="social-button" target="_blank"><img src="/images/social/icon_linkedin.svg" width="29" height="30" alt="LinkedIn" /></a>
                    <a href="#" class="social-button" target="_blank"><img src="/images/social/icon_youtube.svg" width="29" height="30" alt="YouTube" /></a> -->
                  </div>
                </div>
                <div class="column">
                  Contact info
                  <div class="social-buttons small-text">
                    <p>Email: secretary@combinedactors.org</p>
                  </div>
                </div>
                <div class="column"></div>
              </div>
            </div>


            <div class="links-primary">
              <ul>
                <li><router-link :to="{name: 'home'}">Home</router-link></li>
                <li><router-link :to="{name: 'about'}">About</router-link></li>
                <li><router-link :to="{name: 'contact'}">Contact us</router-link></li>
                <li><router-link :to="{name: 'combinations'}">Combinations newsletter</router-link></li>
                <li><router-link :to="{name: 'blogs'}">Blog</router-link></li>
                <!-- <li><router-link :to="{name: 'contactWithPreselectedSubject', params: {preselectSubject: 'unsubscribe'}}">Unsubscribe</router-link></li>
                <li><router-link :to="{name: 'terms'}">Terms &amp; conditions</router-link></li>
                <li><router-link :to="{name: 'privacy'}">Privacy Policy</router-link></li> -->
              </ul>
            </div>
            <div class="copyright">
              © {{ new Date().getFullYear() }} Combined Actors of Cambridge. Designed by: <a href="http://sticky-ux.com/">StickyUX</a>
            </div>
          </div>
        </section>
  </footer>
</template>

<script>
// import Api from '@/config/Api'
export default {
    computed: {
        getContentLoaded() {
            return this.$store.getters.getContentLoaded
        },
    },
}
</script>

<style>
#footer {
    background-color: #172433;
    padding: 0;
}
.footer-upper {
    background: white;
    border-top: 2px solid #172433;
    /* padding: 1.5em 2em; */
}
.footer-lower {
    /* padding: 1.5em 1em; */
    background: #172433;
    text-align: center;
    color: #aaaaaa;  
    margin-top: 4em;
}
.footer-lower a {
    color: white;
    text-decoration: none;
}
.links-secondary>div {
    display: inline-block;
    vertical-align: top;
    margin: 0em 4em;
}
.links-secondary .social-button {
    display: inline-block;
    margin: 0.6em 0.2em;
}
.links-secondary img {
    vertical-align: top;
}
.links-primary ul li {
    display: inline-block;
    margin: 1.5em 1em;
}
.small-text {
  font-size: 70%;
}

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue